import {
  GET_STAFF_BY_EMAIL_SUCCESS,
  GET_STAFF_BY_EMAIL,
  GET_STAFF_BY_EMAIL_FAIL,
  GET_LANG_TIME_ZONE,
  GET_LANG_TIME_ZONE_SUCCESS,
  GET_LANG_TIME_ZONE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  staffData: [],
  langTime: [],
  error: null,
};

const Staff = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_STAFF_BY_EMAIL:
      return {
        ...state,
        staffData: [],
      };

    case GET_STAFF_BY_EMAIL_SUCCESS:
      return {
        ...state,
        staffData: action.payload,
      };

    case GET_STAFF_BY_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LANG_TIME_ZONE:
      return {
        ...state,
      };

    case GET_LANG_TIME_ZONE_SUCCESS:
      return {
        ...state,
        langTime: action.payload,
      };

    case GET_LANG_TIME_ZONE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Staff;
